import React from "react";

const PinUpdateSuccess = ({ data, close }) => {

    // console.log(data);
    return (
        <div>
            {
                (data?.extra === `pin-update`) &&
                <div>
                    <div className="mb-3 d-flex justify-content-center align-items-center"
                        style={{ color: "var(--white)", }}
                    >
                        <p className="mb-0">{`Your Username : ${data?.credential?.username} - Your new PIN : ${data?.credential?.pin}`}</p>
                        {/* <p className="mb-0">{`PIN: ${data?.credential?.pin}`}</p> */}
                    </div>
                    <div>
                        <p>
                            <small
                                className="fw-bold red-text"
                            >
                                {`Your account has been fully updated you can now login with the new PIN system.`}
                            </small>
                        </p>
                        <p>
                            <small
                                className="fw-bold red-text"
                            >
                                {`Save your account information or keep it with a screenshot.`}
                            </small>
                        </p>
                    </div>
                </div>
            }
        </div>
    );
};

export default PinUpdateSuccess;